import React, {Component} from 'react';
import AddPositionView from "./AddPositionView";
import {Growl} from "primereact/growl";
import {CommonService} from "../../../../service/commons/CommonService";
import {CaptureGuaranteesService} from "../../../../service/ptt/captureGuarantees/CaptureGuaranteesService";


export default class AddPositionContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables.
     * Se toma el elemento a editar que viene de la pantalla anterior.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     *              Trae el elemento de la pantalla anterior para editar.
     */
    constructor(props) {
        super(props);
        this.commonService = new CommonService();
        this.captureGuaranteesService = new CaptureGuaranteesService();
        this.accountDropDown = React.createRef();

        this.state = {
            returnPath: this.props.location.state.returnPath,
            positionData: {
                accountObject: {},
                tipoValor: '',
                emisora: '',
                serie: '',
                cuenta: '',
                cantidadTitulos: '',
            },
            isValidEm: false,
            isLoading: false,
        };

        this.onChangeInputText = this.onChangeInputText.bind(this);
        this.onChangeAccount = this.onChangeAccount.bind(this);
        this.validateEmisora = this.validateEmisora.bind(this);
        this.savePosition = this.savePosition.bind(this);
        this.returnCaptureGuaranteesPage = this.returnCaptureGuaranteesPage.bind(this);
        this.loading = this.loading.bind(this);
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }

    /**
     * Función que maneja el cambio de valor en los campos de texto
     * y los coloca en el state dentro del objeto que se va a editar.
     * @param event Contiene el valor que fue modificado en la vista.
     */
    onChangeInputText(event) {
        const {name, value} = event.target;
        let positionDataAux = this.state.positionData;
        positionDataAux[name] = value;
        this.setState({positionData: positionDataAux,})
    }

    /**
     * Función que maneja el cambio en el dropdown de cuenta
     * se guarda la opción elegida en una variable del estado
     * @param event Evento que trae el valor que se eligió.
     */
    onChangeAccount(event) {
        const {name, value} = event.target;
        let positionDataAux = this.state.positionData;
        positionDataAux[name] = value[name];
        positionDataAux['accountObject'] = value
        this.setState({positionData: positionDataAux,})
    }

    /**
     * Función que realiza una consulta al back para validar si
     * los datos ingresados para la emisora son válidos.
     * Si son válidos, regresa la información de la emisora
     * y agregar una nueva posición.
     */
    validateEmisora() {
        if ((this.state.positionData.tipoValor !== "") &&
            (this.state.positionData.emisora !== "") &&
            (this.state.positionData.serie !== "")) {
            this.loading();
            this.commonService.getInstrumentData(
                this.state.positionData.emisora,
                this.state.positionData.serie,
                this.state.positionData.tipoValor
            ).then(
                data => {
                    if (data.message && data.message !== '') {
                        this.growl.show({severity: 'error', summary: 'Error.', detail: data.message});
                        this.setState({isLoading: false,})
                    }
                    let emObject = data.payload[0];
                    let positionDataAux = this.state.positionData;
                    positionDataAux['cupon'] = emObject['cupon'];
                    positionDataAux['isin'] = emObject['isin'];
                    positionDataAux['precio'] = emObject['precio24'];
                    positionDataAux['fechaVence'] = emObject['fechaVence'];
                    this.setState({
                        isLoading: false,
                        isValidEm: true,
                        positionData: positionDataAux,
                    })
                }
            )
        } else {
            this.setState({isValidEm: false,});
            this.growl.show({severity: 'error', summary: 'Error.', detail: 'Llenar los campos requeridos'});
        }
    }

    /**
     * Función que consume a CaptureGuaranteesService para guardar los datos
     * del elemento nuevo.
     * Se hace una validación que estén presentes los datos obligatorios.
     */
    savePosition() {
        this.validateEmisora();
        if (this.state.isValidEm && (this.state.positionData.cuenta !== "") &&
            (this.state.positionData.cantidadTitulos !== "")) {
            this.captureGuaranteesService.saveEmisora(this.state.positionData)
                .then(res => {
                    if (res.message && res.message === 'Success') {
                        this.growl.show({
                            severity: 'Info', summary: 'Success.',
                            detail: "Datos guardados correctamente"
                        });
                        this.returnCaptureGuaranteesPage();
                    } else if (res.error && res.error !== '') {
                        this.growl.show({
                            severity: 'error', summary: 'Error.',
                            detail: res.error
                        });
                    }
                });
        } else {
            this.growl.show({severity: 'error', summary: 'Error.', detail: 'Llenar los campos requeridos'});
        }
    }

    /**
     * Función que regresa a la pantalla de Captura de Garantías
     */
    returnCaptureGuaranteesPage() {
        this.setState({isLoading: false,});
        this.props.history.push({
            pathname: this.state.returnPath,
        });
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {positionData, isLoading} = this.state

        return (
            <AddPositionView
                positionData={positionData}
                messagesGrowl={messagesGrowl}
                isLoading={isLoading}
                accountDropDown={this.accountDropDown}
                loading={this.loading}
                onChangeAccount={this.onChangeAccount}
                onChangeInputText={this.onChangeInputText}
                validateEmisora={this.validateEmisora}
                savePosition={this.savePosition}
                returnCaptureGuaranteesPage={this.returnCaptureGuaranteesPage}
            />
        );
    }
}
